import "./App.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./Router";
import useInactivityLogout from "./custom_hooks/useInactivityLogout";
import Cookies from "js-cookie";
import { message } from "antd";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { logout } from "./features/auth/authSlice";

function App() {
  const dispatch = useDispatch();
  const handleLogout = async () => {
    await dispatch(logout());
    await localStorage.clear();
    await Cookies.remove("refreshToken");
    await toast.error("You have been logged out due to inactivity.");
    window.location = "/#/login";
  };
 
  useInactivityLogout(handleLogout, 60 * 60 * 1000);
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
